





























import { Vue, Component, Prop } from 'vue-property-decorator'

import { TravelCalculateResult } from '@/types/all';

@Component
export default class TravelCalculationResult extends Vue {
  @Prop() data!: TravelCalculateResult;

  public next(): void {
    this.$emit("next");
  }

  public goBack(): void {
    this.$emit("goBack");
  }
}
